import { useContext } from 'react';
import { GlobalState } from "./../../context/globalState";
import { Row, Col, ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";
import Header from "./../../components/header";
import Intro from "./components/1-Intro";
import Packeds from "./components/2-Packeds";
import BuyerInfo from "./components/3-BuyerInfo";
import PaymentInfomation from "./components/4-PaymentInfomation";
import Helper from "./../../lib/helper";


const Home = () => {
  const { step, isMobile } = useContext(GlobalState);

  const RenderPage = () => {
    switch (step) {
      case 1:
        return (<Intro />);
      case 2:
        return (<Packeds />);
      case 3:
        return (<BuyerInfo />);
      case 4:
        return (<PaymentInfomation />);
      default:
        break;
    }
  }

  return (
    <Row>
      {
        Helper.getParamUrlByKey('platform') !== 'app' &&
        <Col xs={24}>
          <Header />
        </Col>
      }
      <Col xs={24} xl={24}>
        <ConfigProvider locale={viVN}
          theme={{
            token: {
              fontSize: isMobile ? 14 : 16,
            },
            components: {
              Input: {
                fontSize: isMobile ? 14 : 16,
              },
              Message: {
                fontSize: isMobile ? 14 : 16,
              },
              Notification: {
                fontSize: isMobile ? 14 : 16,
              },
              Modal: {
                fontSize: isMobile ? 14 : 16,
              }
            }
          }}
        >
          <div style={{ padding: isMobile ? "15px 15px" : '30px 50px' }}>
            {RenderPage()}
          </div>
        </ConfigProvider>
        <div style={{ height: isMobile ? ((step === 3 || step === 2) ? 165 : 94) : 130 }}></div>
      </Col>
    </Row>
  );
}

export default Home;